<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="流水线">
              <a-input v-model="filterForm.name" placeholder="服务名称" class="form-model-item" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="服务类型">
              <a-select v-model="filterForm.service_type" @change="handleChange">
                <a-select-option :value="1"> 后端 </a-select-option>
                <a-select-option :value="2"> 前端 </a-select-option>
                <a-select-option :value="3"> Apple </a-select-option>
                <a-select-option :value="4"> Android </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getServiceList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="历史构建" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="pipeline_id" :loading="loading" @change="handlePageChange">
        <span slot="action" slot-scope="text, record">
          <a-button type="primary" shape="circle" icon="caret-right" @click="onDetail(record)">查看详情</a-button>
        </span>
      </a-table>
    </a-card>
    <service-drawer :visible="drawerVisible" :service-id="serviceId" @close="close" />
  </div>
</template>

<script>
import ServiceDrawer from '@/pages/system/components/ServiceDrawer';
import { serviceList, serviceDelete } from '@/api/system/service';
const columns = [
  {
    title: '服务ID',
    dataIndex: 'service_id',
    key: 'service_id',
    align: 'center',
    minWidth: 60
  },
  {
    title: '服务名称',
    dataIndex: 'service_name',
    key: 'service_name'
  },
  {
    title: '服务类型',
    key: 'service_type',
    dataIndex: 'service_type',
    align: 'center',
    scopedSlots: { customRender: 'service_type' }
  },
  {
    title: '负责人',
    dataIndex: 'owner',
    key: 'owner',
    align: 'center',
    scopedSlots: { customRender: 'owner' }
  },
  {
    title: '备注',
    key: 'description',
    dataIndex: 'description'
  },
  {
    title: '关联项目',
    key: 'projects',
    dataIndex: 'projects',
    scopedSlots: { customRender: 'projects' }
  }
];

export default {
  components: {
    ServiceDrawer
  },
  data() {
    return {
      filterForm: {
        name: null,
        service_type: null,
        project_id: parseInt(this.$route.params.project_id) || null,
        page_size: 10,
        page_number: 1
      },
      projectId: parseInt(this.$route.params.project_id) || null,
      loading: false,
      drawerVisible: false,
      serviceId: null,
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      expand: false,
      tableData: [],
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  mounted() {
    this.getServiceList();
  },
  methods: {
    handleChange() {
      this.filterForm.page_number = 1;
      this.getServiceList();
    },

    // 点击添加
    onAdd() {
      this.serviceId = null;
      this.drawerVisible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.serviceId = record.service_id;
      this.drawerVisible = true;
    },

    // 点击重置
    onReset() {
      this.filterForm = {
        name: null,
        service_type: null,
        project_id: parseInt(this.$route.params.project_id) || null,
        page_size: 10,
        page_number: 1
      };
      this.getServiceList();
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取服务列表
    async getServiceList() {
      this.loading = true;
      const { code, message, data } = await serviceList(this.filterForm);
      if (code === 2000) {
        this.tableData = data.services;
        this.pagination.total = data.total;
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.warning(message);
      }
    },

    // 删除服务
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该服务吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          const { code, message } = await serviceDelete({ service_id: record.service_id, project_id: this.projectId });
          if (code === 2000) {
            self.$message.success('删除成功');
            self.getServiceList();
          } else {
            self.$message.warning(message);
          }
        }
      });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getServiceList();
    },

    // 关闭弹窗
    close() {
      this.drawerVisible = false;
      this.serviceId = null;
      this.getServiceList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
